import { useEffect } from "react";
import { OrderDetailsViewModel } from "../../viewmodels/orders/OrderDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import CreateNewOrderForm from "../../components/forms/orders/CreateNewOrderForm";
import SimpleNotification from "../../components/SimpleNotification";
import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import { useParams } from "react-router-dom";
import AuditActionLink from "../../components/audit/AuditActionLink";

function OrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { orderId } = useParams();

  const {
    carriers,
    getCarriersForDropdown,
    customers,
    getCustomersForDropdown,
    loading,
    showSimpleNotification,
    setEmptyModelOpen,
    setShowSimpleNotification,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateOrderApiCall,
    getOrderDetails,
    order,
    onUpdateOrderItem,
    onCreatePriceSplit,
    onUpdatePriceSplit,
    onDeletePriceSplit,
    onUpdateSourceItemTax,
    taxRateOptions,
    getTaxRatesForDropdown,
    printOrderInvoice,
    printShippingSummary,
    printShippingDetails,
  } = OrderDetailsViewModel(logout, orderId, addSnackbar);

  useEffect(() => {
    getCustomersForDropdown();
    getCarriersForDropdown();
    getTaxRatesForDropdown();
    getOrderDetails();
  }, []);

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2 px-4 py-6 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto flex items-center">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              Invoice #: {order.invoice_number}
            </h1>
            {orderId ? (
              <AuditActionLink
                slug="order"
                id={orderId}
                name={order.invoice_number}
              />
            ) : null}
          </div>
          {loading ? (
            <></>
          ) : (
            <div className="mt-5">
              <CreateNewOrderForm
                carriers={carriers}
                customers={customers}
                isEdit={true}
                loading={loading}
                setEmptyModelOpen={setEmptyModelOpen}
                showErrorModal={showErrorModal}
                updateOrderApiCall={updateOrderApiCall}
                setSlideOver={setSlideOver}
                order={order}
                onUpdateOrderItem={onUpdateOrderItem}
                onCreatePriceSplit={onCreatePriceSplit}
                onUpdatePriceSplit={onUpdatePriceSplit}
                onDeletePriceSplit={onDeletePriceSplit}
                onUpdateSourceItemTax={onUpdateSourceItemTax}
                taxRateOptions={taxRateOptions}
                printOrderInvoice={printOrderInvoice}
                printShippingSummary={printShippingSummary}
                printShippingDetails={printShippingDetails}
                closed={order.status === 6}
              />
            </div>
          )}
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails)
);
